// Google Analytics wird erst nach ausdrücklicher Einwilligung geladen.
//
// Zuvor lief getAnalytics() beim Start der App, also bevor der Cookie-Banner
// überhaupt beantwortet war. Ein Ablehnen hätte daran nichts geändert — die
// Messung lief bereits.
//
// firebase/analytics wird per dynamischem Import nachgeladen. Wer ablehnt,
// lädt den Code gar nicht erst.

export const CONSENT_COOKIE = 'AugensternCookieConsent';

let gestartet = false;

export function hasConsent() {
  return document.cookie
    .split(';')
    .some((eintrag) => eintrag.trim() === `${CONSENT_COOKIE}=true`);
}

export async function enableAnalytics() {
  if (gestartet) {
    return;
  }
  gestartet = true;
  try {
    const [{ getAnalytics }, { app }] = await Promise.all([
      import('firebase/analytics'),
      import('./firebase'),
    ]);
    getAnalytics(app);
  } catch (error) {
    console.warn('Analytics konnte nicht gestartet werden:', error);
  }
}

// Beim Seitenaufruf: War schon einmal zugestimmt, gilt das weiter.
export function enableAnalyticsIfConsented() {
  if (hasConsent()) {
    enableAnalytics();
  }
}
